import { FilterOption } from "@/components/optimizer/filters/types";
import { getSportsbookLogoPath } from "@/lib/sportsbook-logo";
import { SPORTSBOOKS, sportsbookIdToDisplay } from "@/lib/sportsbook-registry";
import {
  SPORTSBOOK_SURFACE,
  getSportsbookSurfacePolicy,
} from "@/lib/sportsbook-preferences";

export function getSportsbookImagePath(book: string): string {
  return getSportsbookLogoPath(book);
}

export function getBookDisplayName(book: string, fallback?: string | null): string {
  const canonicalDisplay = sportsbookIdToDisplay(book);
  if (canonicalDisplay && canonicalDisplay !== book) return canonicalDisplay;
  const displayNames: Record<string, string> = {
    draftkings: "DraftKings",
    fanduel: "FanDuel",
    betmgm: "BetMGM",
    caesars: "Caesars",
    fanatics: "Fanatics",
    novig: "Novig",
    prophetx: "ProphetX",
    dabble: "Dabble",
    fliff: "Fliff",
    betr: "Betr",
    pinnacle: "Pinnacle",
    circa: "Circa",
    parlayplay: "ParlayPlay",
    underdog: "Underdog",
    sleeper: "Sleeper",
    hardrockbet: "Hard Rock Bet",
    hardrock: "Hard Rock",
    kalshi: "Kalshi",
    polymarket: "Polymarket",
    rebet: "Rebet",
    prizepicks: "PrizePicks",
    kambi: "Kambi",
    betonline: "BetOnline",
    propbuilder: "PropBuilder",
    draftkingspredictions: "DK Predictions",
    bovada: "Bovada",
    betrsportsbook: "Betr Sportsbook",
    shuffle: "Shuffle",
    sportzino: "Sportzino",
    sportsbettingag: "SportsBetting AG",
    dkpick6: "DK Pick6",
    tailgate: "Tailgate",
    sleeperpredict: "Sleeper Markets",
    courtside: "Courtside",
    boomsports: "Boom",
    chalkboardpicks: "Chalkboard Picks",
    chalkboardssp: "Chalkboard",
    smacktok: "SmackTok",
  };
  return displayNames[book] || fallback?.trim() || book;
}

const EV_SNIPER_POLICY = getSportsbookSurfacePolicy(SPORTSBOOK_SURFACE.EV_SNIPER);

export const ACTIONABLE_BOOK_OPTIONS: Array<FilterOption<string>> =
  EV_SNIPER_POLICY.supportedBookIds.map(
    (bookId) => ({ value: bookId, label: SPORTSBOOKS[bookId].display }),
  );

export const BOOK_OPTIONS: Array<FilterOption<string>> = Array.from(
  new Set([
    ...EV_SNIPER_POLICY.supportedBookIds,
    ...EV_SNIPER_POLICY.analyticalBookIds,
  ]),
).map((bookId) => ({ value: bookId, label: SPORTSBOOKS[bookId].display }));

export const ALL_BOOKS: Array<string> = ACTIONABLE_BOOK_OPTIONS.map(
  (option: FilterOption<string>) => option.value,
);
